import styled from "styled-components";

export const PageContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: flex-start;
	min-height: 100vh;
	padding: 1rem;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		align-items: center;
		padding: 2rem;
	}
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	background: white;
	padding: 1.5rem;
	border-radius: 10px;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		flex-direction: row;
		max-width: 1000px;
		padding: 2rem;
	}
`;

export const InfoSection = styled.div`
	padding: 0 0 1.5rem 0;
	border-bottom: 1px solid #eee;
	margin-bottom: 1.5rem;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		flex: 1;
		padding-right: 2rem;
		border-bottom: none;
		margin-bottom: 0;
	}

	ul {
		list-style: none;
		padding: 0;
		margin: 0;
	}
`;

export const FormSection = styled.div`
	width: 100%;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		flex: 1;
		padding: 0 0 0 2rem;
	}
`;

export const Title = styled.h2`
	color: ${({ theme }) => theme.palette.primary.blue500};
	font-weight: 600;
	margin-bottom: 1rem;
	font-size: 1.5rem;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		font-size: 1.8rem;
		margin-bottom: 1.5rem;
	}
`;

export const Input = styled.input`
	width: 100%;
	padding: 0.7rem;
	margin: 0.5rem 0;
	border: 1px solid #d1d1d1;
	border-radius: 5px;
	font-size: 0.9rem;
	outline: none;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		padding: 0.8rem;
		font-size: 1rem;
	}

	&:focus {
		border-color: ${({ theme }) => theme.palette.primary.blue500};
	}
`;

export const RadioGroup = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
	gap: 0.8rem;
	margin: 0.8rem 0;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		gap: 0.5rem;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
		flex-wrap: nowrap;
		gap: 0;
	}
`;

export const Label = styled.label`
	font-size: 0.9rem;
	color: #333;
	display: flex;
	align-items: center;
	gap: 0.5rem;
	white-space: nowrap;
	padding: 0.3rem 0;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		font-size: 0.95rem;
	}
`;

export const Button = styled.button`
	width: 100%;
	padding: 0.8rem;
	background-color: ${({ theme }) => theme.palette.primary.blue500};
	color: white;
	border: none;
	border-radius: 5px;
	font-size: 1rem;
	cursor: pointer;
	transition: background 0.3s ease;
	margin-top: 1rem;

	&:hover {
		background-color: ${({ theme }) => theme.palette.primary.blue500};
	}
`;

export const ContactButtons = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	margin-top: 1rem;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		flex-direction: row;
		justify-content: space-between;
		gap: 1rem;
	}
`;

export const ContactButton = styled.button`
	width: 100%;
	padding: 0.5rem;
	border: 2px solid ${({ theme }) => theme.palette.primary.blue500};
	background: transparent;
	color: ${({ theme }) => theme.palette.primary.blue500};
	font-weight: 500;
	border-radius: 12px;
	font-size: 0.95rem;
	cursor: pointer;
	transition: all 0.3s ease;

	a {
		all: unset;
		cursor: pointer;
		display: inline-block;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		width: 48%;
		font-size: 1rem;
	}

	&:hover {
		background-color: ${({ theme }) => theme.palette.primary.blue500};
		color: white;
	}
`;

export const FeatureItem = styled.li`
	font-size: 0.95rem;
	color: #333;
	display: flex;
	align-items: center;
	gap: 0.8rem;
	margin-bottom: 1rem;
	padding-left: 0.5rem;
	position: relative;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
		font-size: 1rem;
		gap: 1rem;
		padding-left: 1rem;
	}

	&::before {
		content: "✓";
		color: ${({ theme }) => theme.palette.primary.blue500};
		font-weight: bold;
		font-size: 1.1rem;
		position: absolute;
		left: -0.5rem;

		@media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
			font-size: 1.2rem;
			left: -0.8rem;
		}
	}
`;

export const FormsParagr = styled.p`
	font-weight: 600;
	font-size: 0.75rem;
	padding: 1rem;
	text-align: center;
`;

export const ErrorMessage = styled.p<{ isGlobal?: boolean }>`
	color: red;
	font-size: 0.8rem;
	margin-top: -0.5rem;
	margin-bottom: 0.5rem;
	text-align: ${({ isGlobal }) => (isGlobal ? 'center' : 'left')};
	${({ isGlobal }) => (isGlobal ? 'margin-top: 1rem;' : '')}
`;

export const SuccessMessage = styled.p`
	color: green;
	text-align: center;
	margin-top: 1rem;
	font-size: 1rem;
	font-weight: 500;
`;